const fileType = [
  {
    name: "pdf",
    fileType: "application/pdf"
  },
  {
    name: "audio",
    fileType: "audio/mp3"
  },
  {
    name: "video",
    fileType: "video/x-matroska"
  },
  {
    name: "video",
    fileType: "video/quicktime"
  },
  {
    name: "video",
    fileType: "video/mp4"
  },
  {
    name: "video",
    fileType: "video/mpeg"
  },
  {
    name: "video",
    fileType: "video/x-msvideo"
  },
  {
    name: "video",
    fileType: "video/x-msvideo"
  },
  {
    name: "zip",
    fileType: "application/zip"
  },
  {
    name: "sheet",
    fileType:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  },
  {
    name: "doc",
    fileType: "application/msword"
  },
  {
    name: "doc",
    fileType:
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  },
  {
    name: "doc",
    fileType:
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  },
  {
    name: "doc",
    fileType:
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  },
  {
    name : 'image',
    fileType :'image/svg+xml'  
  },
  {
    name : 'image',
    fileType :'image/png'  
  },
  {
    name : 'image',
    fileType :'image/gif'  
  },
  {
    name : 'image',
    fileType :'image/jpeg'  
  },
];

export default fileType;



// WEBPACK FOOTER //
// ./src/services/common/fileType.js